import { useState } from 'react';
import { useSelector } from 'react-redux';
import { ITag } from '../../../../entities/module/private-template-module-tag/api/types';
import { SearchTagBar } from '../../../search-tag-bar';
import { workshopModuleApi, workshopModuleSelectors } from '../../../../entities/module/workshop-module';
import { useBindWorkshopModuleTag } from '../../model/services/useBindWorkshopModuleTag';
import { useCreateWorkshopModuleTag } from '../../../../features/module/tag/create/api';

export const SearchWorkshopModuleTagBar = () => {
	const [search, setSearch] = useState('');

	const moduleId = useSelector(workshopModuleSelectors.getBindingModuleId);

	const { data: availableTagsData } = workshopModuleApi.useGetAvailableModuleTagsQuery({
		moduleId,
	});

	const { data: moduleData } = workshopModuleApi.useGetWorkshopModuleQuery({
		moduleId: moduleId || '',
	});

	const { onCreateTag } = useCreateWorkshopModuleTag();
	const { onBindTag } = useBindWorkshopModuleTag(moduleId);

	const bindCreatedTag = async (name: string): Promise<ITag | null> => {
		const newTag = await onCreateTag(name);
		if (newTag) {
			await onBindTag({ id: newTag.id });
			return newTag;
		}
		return null;
	};

	return (
		<SearchTagBar
			search={search}
			bindTag={onBindTag}
			createTag={bindCreatedTag}
			setSearch={setSearch}
			tags={availableTagsData?.moduleTags}
			templateTags={(moduleData?.module?.tags || []) as ITag[]}
		/>
	);
};
